import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const portfolioGroupsSelection = {
    name: "Portfolio Groups Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose portfolio group id(s)",
    defaultConfig: {
        defaultValue: null,
        key: "PortfolioGroups",
    },
    type: "input",
    category: "dashboard",
};
